import React from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    DialogContentText,
    Button
} from "@mui/material";

/**
 * PayrollsPopup
 * Reusable modal alert dialog supporting confirm, cancel, delete, and success states.
 */
const PayrollsPopup = ({
    open,
    popupType,     // "cancel" | "delete" | "success" | "confirm"
    message,
    onConfirm,
    onCancel,
    onClose,
    onDismiss,
    confirmText,
    cancelText,
}) => {

    const showConfirmButtons = popupType === "cancel" || popupType === "delete" || popupType === "confirm";

    const handleDialogClose = (event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            if (onDismiss) {
                onDismiss(event, reason);
                return;
            }
            if (onClose) {
                onClose(event, reason);
                return;
            }
            return;
        }
        if (onDismiss) {
            onDismiss(event, reason);
            return;
        }
        if (onClose) {
            onClose(event, reason);
            return;
        }
        if (onCancel) {
            onCancel(event, reason);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleDialogClose}
            sx={{
                '& .MuiDialog-container': {
                    alignItems: 'flex-start',
                }
            }}
            PaperProps={{
                sx: {
                    width: "28rem", // Standardized width for consistency
                    borderRadius: "0.5rem",
                    p: 2,
                    top: 0,
                    marginTop: 0,
                }
            }}
            BackdropProps={{
                sx: { backgroundColor: "rgba(0,0,0,0.3)" }
            }}
        >

            {/* Message */}
            <DialogContent sx={{ p: 0, pb: 1 }}>
                <DialogContentText sx={{ fontSize: 12, color: "#333", fontWeight: 500 }}>
                    {message}
                </DialogContentText>
            </DialogContent>

            {/* Buttons */}
            <DialogActions sx={{ p: 0, font: '12px' }}>
                {showConfirmButtons ? (
                    <>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={onCancel}
                            sx={{
                                textTransform: "none",
                                // borderColor: "#555",
                                backgroundColor: "#777",
                                fontSize: '0.75rem',
                                color: "white",

                                borderRadius: "5px",
                                px: 1,
                                minWidth: "40px",
                                "&:hover": { backgroundColor: "#555" }
                            }}
                        >
                            {cancelText || (popupType === "confirm" ? "No" : "Cancel")}
                        </Button>

                        <Button
                            variant="outlined"
                            size="small"
                            onClick={onConfirm}
                            sx={{
                                textTransform: "none",
                                // fontSize: '0.7rem', padding: '4px px' ,
                                px: 1,
                                minWidth: "40px",
                                fontSize: '0.75rem',

                                color: "white",
                                backgroundColor: "#2782EC",
                                borderRadius: "5px",
                                "&:hover": { backgroundColor: "#1976d2" }
                            }}
                        >
                            {confirmText || (popupType === "confirm" ? "Yes" : "Ok")}
                        </Button>
                    </>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={onConfirm}

                        sx={{
                            textTransform: "none",
                            px: 1,
                            minWidth: "40px",
                            fontSize: '0.75rem',
                            borderRadius: "8px",



                            color: "white",
                            backgroundColor: "#2782EC",
                            "&:hover": { backgroundColor: "#1976d2" }
                        }}
                    >
                        Ok
                    </Button>
                )}
            </DialogActions>

        </Dialog>
    );
};

export default PayrollsPopup;
